"use strict";
/**
 * @license
 * Copyright 2020 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
var UserAgent = /** @class */ (function () {
    function UserAgent(agents) {
        this.agents = agents;
        this.stringValue = this.agents.slice().map(formatUserAgent).join(" ");
    }
    UserAgent.prototype.addAgent = function (agent) {
        return new UserAgent(this.agents.concat([agent]));
    };
    UserAgent.prototype.toString = function () {
        return this.stringValue;
    };
    return UserAgent;
}());
exports.UserAgent = UserAgent;
function formatUserAgent(userAgent) {
    var productName = userAgent.productName, productVersion = userAgent.productVersion;
    return productName + "/" + productVersion;
}
//# sourceMappingURL=userAgent.js.map